import { render, staticRenderFns } from "./FreeDelivery.vue?vue&type=template&id=635c092f&scoped=true&"
import script from "./FreeDelivery.vue?vue&type=script&lang=js&"
export * from "./FreeDelivery.vue?vue&type=script&lang=js&"
import style0 from "./FreeDelivery.vue?vue&type=style&index=0&id=635c092f&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c092f",
  null
  
)

export default component.exports